// Deps
import React from 'react'
import { render } from 'react-dom'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { Router, browserHistory } from 'react-router'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'

import { createMiddleware } from 'redux-beacon'
import FacebookPixel, { facebookPixelEvents } from './tracking/facebook-pixel'

//action to load translation
import { setTranslations } from './actions/app'

// Reducers
import rootReducer from './reducers'

//Styles
// import '../assets/styles/app.scss'
import '../assets/styles/app.scss'
import 'react-select/dist/react-select.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import routes from './routes/routes.js'

// Load Bootstrap
require('bootstrap/dist/css/bootstrap.css')
require('font-awesome/css/font-awesome.css')
require('tailwindcss/dist/tailwind.min.css')

// Facebook Pixel
const fp = FacebookPixel()
const fpMiddleware = createMiddleware(facebookPixelEvents, fp)

// Middlewares
const middlewares = [
  window.devToolsExtension && window.devToolsExtension(),
  applyMiddleware(fpMiddleware, thunk, routerMiddleware(browserHistory)),
]


const locale = navigator.language.split('-')
var language = (
  `${locale[0]}-${locale[0]}`
)

if (typeof window !== undefined && window.location.search.indexOf('lang') !== -1) {
  const lang = window.location.search
    .slice(1)
    .split('&')
    .find(param => param.indexOf('lang=') !== -1)
  language = lang ? lang.split('=')[1] : language
}

const loadTranslations = (l) =>
  fetch(`/i18n/${ l }.json`)
    .then((res) => res.json())


// Store
export const store = createStore(rootReducer, ...middlewares)

// History
const history = syncHistoryWithStore(browserHistory, store)
// App Render
loadTranslations(language)
	.then((translations) => {
		store.dispatch(setTranslations(translations, language))
		render(
			<Provider store={store}>
        <Router history={history} routes={routes}>
        </Router>
      </Provider>,
			document.getElementById('react-app')
		)
  })
  .catch((error) => {
    return error
  })



// WEBPACK FOOTER //
// ./src/index.js